var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPills = function SvgPills(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 44 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6E7780",
    fillRule: "evenodd",
    d: "m31 34.607 4.778-4.779a4 4 0 0 1 5.657 5.657L36.92 40H40a4 4 0 1 1 0 8h-7c-.765 0-1.48-.215-2.089-.588A1 1 0 0 1 30 48H1a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h6v-2H4a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h23a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-3v2h6a1 1 0 0 1 1 1zM14.5 23v-3.5a1 1 0 0 1 2 0V23H20a1 1 0 0 1 0 2h-3.5v3.5a1 1 0 0 1-2 0V25H11a1 1 0 0 1 0-2zM22 12v-2H9v2zM2 14v32h27V14zM5 2v6h21V2zm2 32h17a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2m0 5h17a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2m26 3a2 2 0 1 0 0 4h7a2 2 0 1 0 0-4zm-.757-5.808a2 2 0 1 0 2.828 2.829l4.95-4.95a2 2 0 1 0-2.829-2.828z"
  })));
};
export default SvgPills;